import { Padlock } from '@/components/Icons/Padlock';
export const OverlaySubtitle = () => <div className="itemes-center flex flex-row gap-1.5 whitespace-nowrap rounded-3xl bg-gray-950/50 px-3 py-1 text-center font-sans text-sm text-white" data-sentry-component="OverlaySubtitle" data-sentry-source-file="OverlaySubtitle.tsx">
    <Padlock data-sentry-element="Padlock" data-sentry-source-file="OverlaySubtitle.tsx" />
    <span>
      Guaranteed <span className="font-semibold">safe & secure</span> checkout{' '}
    </span>
  </div>;